import React from 'react';

const DownloadIcon = ({ width = '20px', height = '20px', color = '#666666' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 16L7 11l1.4-1.4 2.6 2.6V4h2v8.2l2.6-2.6L17 11l-5 5zM6 20v-2h12v2H6z"
                fill={color}
            />
        </svg>
    );
};

export default DownloadIcon;